import { Component, ViewChild, AfterViewInit, ChangeDetectorRef, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
	FormsModule,
	ReactiveFormsModule,
	FormGroup,
	FormControl,
	NgModel,
	Validators,
	FormArray
} from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { faAbacus } from '@awesome.me/kit-bde9a98016/icons/sharp/solid';

import { IAhsSelectModel, IAhsCheckboxModel, ValidationListDisplayModel } from '@nx-ahs/base-ahs-controls/models';
import {
	AhsTextComponent,
	AhsTextareaComponent,
	AhsSelectComponent,
	AhsDatepickerComponent,
	AhsAutocompleteComponent,
	AhsRadiolistComponent,
	AhsChecklistComponent,
	AhsSwitchComponent,
	AhsMaskedTextComponent,
	AhsChipListboxComponent
} from '@nx-ahs/base-ahs-controls/reactive';
import { FloatLabelType } from '@angular/material/form-field';

@Component({
	selector: 'base-ahs-controls-demo',
	templateUrl: './base-ahs-controls-demo.component.html',
	styleUrls: ['./base-ahs-controls-demo.component.scss'],
	standalone: true,
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatCardModule,
		AhsTextComponent,
		AhsTextareaComponent,
		AhsSelectComponent,
		AhsDatepickerComponent,
		AhsAutocompleteComponent,
		AhsRadiolistComponent,
		AhsChecklistComponent,
		AhsSwitchComponent,
		AhsMaskedTextComponent,
		AhsChipListboxComponent
	]
})
export class BaseAhsControlsDemoComponent implements OnInit {
	fname: string;
	@ViewChild('fnameModel', { read: NgModel })
	fnameModel: NgModel;
	loginForm: FormGroup;

	readonly: boolean = false;

	compState = (val1: number, val2: number) => val1 == val2;
	radioValue = { id: 1 };
	chipList = ['lemon', 'lime', 'apple'];

	options: IAhsSelectModel[];
	checkOptions: IAhsCheckboxModel[] = [
		{
			id: 'check1',
			viewValue: 'check 1 check 1 check 1 check 1 ',
			value: {
				count: 1,
				criteria: { SpecialtyId: 1 },
				description: 'Specialty 1'
			},
			sortValue: 1,
			isSelected: true
		},
		{
			id: 'check2',
			viewValue: 'check 2',
			value: {
				count: 1,
				criteria: { SpecialtyId: 2 },
				description: 'Specialty 2'
			},
			sortValue: 2
		},
		{
			id: 'check3',
			viewValue: 'check 3',
			value: {
				count: 1,
				criteria: { SpecialtyId: 3 },
				description: 'Specialty 3'
			},
			sortValue: 3
		},
		{
			id: 'check4',
			viewValue: 'check 4',
			value: {
				count: 1,
				criteria: { SpecialtyId: 4 },
				description: 'Specialty 4'
			},
			sortValue: 4
		},
		{
			id: 'check5',
			viewValue: 'check 5',
			value: {
				count: 1,
				criteria: { SpecialtyId: 5 },
				description: 'Specialty 5'
			},
			sortValue: 5
		},
		{
			id: 'check6',
			viewValue: 'check 6',
			value: {
				count: 1,
				criteria: { SpecialtyId: 6 },
				description: 'Specialty 6'
			},
			sortValue: 1
		},
		{
			id: 'check7',
			viewValue: 'check 7',
			value: {
				count: 1,
				criteria: { SpecialtyId: 7 },
				description: 'Specialty 7'
			},
			sortValue: 7
		},
		{
			id: 'check8',
			viewValue: 'check 8',
			value: {
				count: 1,
				criteria: { SpecialtyId: 8 },
				description: 'Specialty 8'
			},
			sortValue: 8
		},
		{
			id: 'check9',
			viewValue: 'check 9',
			value: {
				count: 1,
				criteria: { SpecialtyId: 9 },
				description: 'Specialty 9'
			},
			sortValue: 9
		}
	];

	public validationListDisplayModel: ValidationListDisplayModel;

	public floatLabel: FloatLabelType = 'auto';

	ngOnInit() {
		this.validationListDisplayModel = new ValidationListDisplayModel();
		this.validationListDisplayModel.validatorMessages = [
			{
				errorId: 'email',
				message: 'Not a valid email address',
				validator: Validators.email
			},
			{
				errorId: 'minlength',
				message: 'Must be a minimum length of 5 characters.',
				validator: Validators.minLength(5)
			}
			//, {
			//    errorId: 'required',
			//    message: 'email is required',
			//    validator: Validators.required
			//}
		];

		const emailValidators = this.validationListDisplayModel.validatorMessages.map((p) => p.validator);

		this.loginForm = new FormGroup({
			textarea: new FormControl('ressa asdfsad', [Validators.required]),
			date: new FormControl(new Date().toISOString(), [Validators.required]),
			email: new FormControl('', emailValidators),
			select: new FormControl({ id: 2 }),
			autocomplete: new FormControl({
				id: 2,
				viewValue: 'option 2',
				value: { id: 2 }
			}),
			radioList: new FormControl(),
			checklist: new FormArray([]),
			phone: new FormControl(),
			switch: new FormControl(),
			fruits: new FormControl(['apple', 'pear'])
		});

		this.options = [
			{
				id: 1,
				viewValue: 'option 1',
				value: { id: 1 },
				sortValue: 0,
				iconInfo: { icon: faAbacus, iconSize: 'lg' }
			},
			{
				id: 2,
				viewValue: 'option 2',
				value: { id: 2 },
				sortValue: 0,
				iconInfo: { icon: faAbacus, iconSize: 'lg' }
			},
			{
				id: 3,
				viewValue: 'option 3',
				value: { id: 3 },
				sortValue: 0,
				iconInfo: { icon: faAbacus, iconSize: 'lg' }
			},
			{
				id: 4,
				viewValue: 'option 4',
				value: { id: 4 },
				sortValue: 0,
				iconInfo: { icon: faAbacus, iconSize: 'lg' }
			}
		];
	}
}
